export enum TypePageErreur {
	SSO = 0,
	ListeSocietes = 1,
	SalarieConnecte = 2
}



// WEBPACK FOOTER //
// ./src/shared/models/typePageErreur.ts